<template>
    <div class="w-full h-full flex items-center justify-center relative">
        <div class="spin-loader mx-auto" aria-hidden="true"></div>
        <p class="font-medium absolute ml-2">{{ progress }}%</p>
    </div>
</template>

<script>
export default {
    props: ['progress']
}
</script>

<style lang="scss">

@mixin styling($spinner_size, $spinner_thickness) {

  $spinner_speed: .7s;
  $spinner_radius: 80%;
  $spinner_fill_radius: 90px;

  $spinner_inner_circle: $spinner_size - $spinner_thickness;

  $spinner_color: #022c5f;
  $spinner_bg: #00aad2;
  $spinner_inner_bg: #fff;
  
  .spin-loader {
    border-radius: 80%;
    display: block;
    height: $spinner_size;
    width: $spinner_size;
    position: relative;
    animation: spin $spinner_speed linear 0s infinite normal;
    background: $spinner_bg;
  
    &:before,
    &:after {
      content: "";
      display: block;
      position: absolute;
    }
  
    &:before {
      border-radius: 0 $spinner_fill_radius $spinner_fill_radius 0;
      height: $spinner_size;
      width: 50%;
      top: 0; right: 0;
      z-index: 1;
      background: $spinner_color;
      background-image: linear-gradient( $spinner_bg, $spinner_color);
    }
  
    &:after {
      border-radius: $spinner_radius;
      height: $spinner_inner_circle;
      width: $spinner_inner_circle;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
      background: $spinner_inner_bg;
    }
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
}

@media only screen and (max-width: 640px) {
  @include styling($spinner_size: 80px, $spinner_thickness: 23px);
}

@media only screen and (min-width: 640px) {
  @include styling($spinner_size: 90px, $spinner_thickness: 25px);
}

@media only screen and (min-width: 1024px) {
  @include styling($spinner_size: 100px, $spinner_thickness: 30px);
}
</style>